// Domain log — runs as the very first thing on app load, before
// React mount, before any backend call. Useful
// for confirming which environment the iframe is loaded into when a
// build is hitting the wrong API.
try {
  let parentOrigin = null;
  try {
    parentOrigin =
      window.parent !== window ? window.parent.location.origin : null;
  } catch (e) {
    parentOrigin = "(cross-origin — not readable)";
  }
  console.log("🌐 App domain:", {
    ownOrigin: window.location.origin,
    hostname: window.location.hostname,
    href: window.location.href,
    parentOrigin,
    referrer: document.referrer || null,
    backendUrl: process.env.REACT_APP_BACKEND_URL || null,
    edgeQueueUrl: getEdgeQueueUrl(),
  });
} catch (e) {
  // Never let a debug log crash the app boot.
}

// The BlinkID SDK's overlay UI trips the benign "ResizeObserver loop
// completed with undelivered notifications" browser warning, which the
// CRA dev overlay wrongly promotes to a full-screen runtime error.
// Deferring observer callbacks to the next animation frame prevents the
// loop condition at the source. Dev-only: production has no overlay.
if (process.env.NODE_ENV === "development" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./App.css";

import RootComponent from "./root";
import { getEdgeQueueUrl } from "./utils/edge";

const root = createRoot(document.getElementById("root"));
root.render(
  <RootComponent />
);
